import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedWizardDialog } from 'infrastructure/js/components/Dialog/WizardDialog/wizardDialog';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import ScanAssetsStep from './Steps/ScanAssetsStep/scanAssetsStep';
import AssetsValidateStep from '../Common/Steps/AssetsValidateStep/assetsValidateStep';
import MessageDialog from 'infrastructure/js/components/Dialog/MessageDialog/messageDialog';
import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';
import {ImportTypes} from '../../../enums/importTypes';

import './ImportAssetsViaBarcodeWizard.scss';

function mapStateToProps(state) {
  return {
    sData: state.wizards.get('importAssetsViaBarcodeWizard')
  };
}

export default class ImportAssetsViaBarcodeWizard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.wizards.importViaBarcode.');
    this.wizardLabels = createLabelHelper('mat.dialog.wizard.');
    this.assetType = props.sData?.get('importType');
    this.assetTypeLabel = createLabelHelper('mat.entity.type.')?.get?.(this.assetType) ?? '';

    this.steps = [
      {
        name: this.labels.get('scanAssetsStep.name', '', {assetType: this.assetTypeLabel}),
        component: (dialogProps) =>
          <ScanAssetsStep
            {...dialogProps}
            labels={this.labels}
            assetTypeLabel={this.assetTypeLabel?.toLowerCase() ?? ''}
            onBarcodeScanned={this.onBarcodeScanned}
          />
      },
      {
        name: this.labels.get('validateAssetsStep.name', '', {assetType: this.assetTypeLabel}),
        component: (props) =>
          <AssetsValidateStep
            {...props}
            validatedFileData={this.props.sData?.get('validatedFileData')}
            operationStatusLabels={this.labels}
            labels={this.labels}
            assetType={this.assetType}
          />,
      },
    ];
    this.formComponent = ConnectedWizardDialog(mapStateToProps);
  }

  onBarcodeScanned = (scanData) => {
    this.props.actions.scanBarcode(scanData, this.assetType);
  }

  onSubmit = (nextStep, currentStep) => {
    switch (currentStep) {
      case 0: {
        this.props.actions.submitScanAssetsStep(nextStep, this.assetType);
        return;
      }
    }
  };

  onFinish = () => {
    this.props.actions.confirmImport(this.assetType, this.getMessageDialogBuilder(), this.props.reloadParentComponent);
  };

  getMessageDialogBuilder = () => {
    return (response, fnCloseDialog) => {
      const messageAssetTypeLabel = createLabelHelper('mat.wizards.import.types.')?.get?.(this.assetType, '', {count: response.totalJobItems});

      let title = this.labels.get('confirmation.message.title', 'Confirmation', { count: response.totalJobItems, assetType: messageAssetTypeLabel});
      return dialogHelper.BuildDialogDescriptorForBO(response, fnCloseDialog, title, false);
    };
  };

  getCloseConfirmationDialog = () => {
    return (
      {
        titleText: this.wizardLabels.get('closeConfirmation.title'),
        contents:
          <div>
            <MessageDialog.DataRow key={'row1'} label={this.wizardLabels.get('closeConfirmation.line1')} value={''}/>
            <MessageDialog.DataRow key={'row2'} label={this.wizardLabels.get('closeConfirmation.line2')} value={''}/>
          </div> ,
      }
    );
  }

  render() {
    return <this.formComponent
      show={this.props.sData.get('show')}
      id="importAssetsViaBarcodeWizard"
      tabType="wizard-horizontal"
      steps={this.steps}
      titleText={this.labels.get('title', '', {assetType: this.assetTypeLabel})}
      closeConfirmationDialog={this.getCloseConfirmationDialog()}
      defaultButtons={{
        onNextButtonClick: this.onSubmit,
        onFinishButtonClick: this.onFinish
      }}
      onClose={this.props.actions.hide}
      loading={this.props.sData.get('loading')}
    />;
  }
}

ImportAssetsViaBarcodeWizard.propTypes = {
  sData: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};
